import { CSSProperties } from 'react';
import classNames from 'classnames/bind';

import { CoreIcon } from '@autopass-web/mochi-icons';

import check from './check.svg';
import styles from './index.module.sass';

const cx = classNames.bind(styles);

interface checkboxProps {
  isChecked: boolean;
  id: string;
  name: string;
  value?: string;
  onChange?: (e: boolean) => void;
  style?: CSSProperties;
}

const Checkbox = ({
  isChecked,
  id,
  name,
  value,
  onChange,
  style,
}: checkboxProps) => {
  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (onChange) onChange(event.target.checked);
  };

  const checkSpanStyle = cx({
    'checkbox-span': true,
    checked: isChecked,
  });

  return (
    <label htmlFor={id} style={style} className={styles.checkbox}>
      <input
        id={id}
        value={id}
        name={name}
        checked={isChecked}
        type="checkbox"
        hidden
        onChange={onChangeHandler}
      />
      <span className={checkSpanStyle}>
        <CoreIcon src={check} width={10} height={10} />
      </span>
      {value && <span className={styles.text}>{value}</span>}
    </label>
  );
};

export default Checkbox;
